import Button from "../common/Button";
import Morse from "../routes/landing/Morse";
import classNames from "./ContactSales.module.css";

export default function ContactSales() {
  return (
    <div className={classNames.ContactSales}>
      <div>
        <h2>
          AI-powered, real-time translation in voice and captions for 50+
          languages for your Teams meetings, webinars, and town halls
        </h2>
        <Morse />
        <div>
          <h3>
            Users must have an active Langfinity account to access this
            integration.
          </h3>
          <h3>Please contact us to create a Teams integration account</h3>
        </div>
        <Button
          onClick={() => {
            window
              .open("https://calendly.com/d/cs8h-bpy-tzc/langfinity-intro", "_blank")
              ?.focus();
          }}
        >
          Contact us
        </Button>
        <div className={classNames.LinkAndDivider}>
          <div className={classNames.Divider} />
          <a href="https://langfinity.ai" target="_blank" rel="noreferrer">
            About Langfinity
          </a>
        </div>
      </div>
    </div>
  );
}
